import styled from 'styled-components'

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: .5em;

  & > input {
    width: 390px;
    font-size: 1em;
    height: 41px;
  }

  @media (max-width: 646px) {
    display: block;
    margin-bottom: 20px;

    & > input {
      width: 100%;
      margin-left: 0;
    }
  }
`

export const Form = styled.div`
  position: relative;
  margin-bottom: .5em;
`

export const Select = styled.select`
  font-size: 1em;
  overflow: auto;
  @media (max-width: 767px) {
    font-size: .818em;

    option {
        white-space: initial;
    }
  }
`

export const LoaderPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
`

